<template>
    <div>
        <b-row class="activity-group-row">
            <b-col cols="1" class="p-0 flex-column">
                <div class="timeline-date">
                    {{day}}
                </div>
                <div class="al-line h-100">

                </div>
            </b-col>
            <b-col>
                <div class="activities-wrapper">
                    <b-row v-for="(activity,index) in activities" :key="activity.actionID" class="m-0">
                        <div class="row w-100 activity-row" v-b-toggle="activity.actionID">
                            <b-col cols="2">
                                <div class="a-time">
                                    {{activity.timeLabel}}
                                </div>
                            </b-col>
                            <b-col>
                                <div class="a-title">
                                    {{activity.title}}
                                </div>
                            </b-col>
                            <b-col cols="4">

                                <div class="process-item-header-percentage-container" v-if="activity.percentageDone < 100">
                                    <div class="process-item-header-percentage">
                                        <span class="percentage" v-bind:style="{width:activity.percentageDone+ 'px'}"></span>
                                    </div>
                                    <div class="process-item-header-close-icon">
                                        <b-btn variant="flat" class="p-0" @click="$emit('bulkKillTasks',activity)">
                                            <close-cirle-icon class="icon-default closecirlce show m-1"></close-cirle-icon>
                                        </b-btn>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="a-status-count">
                                        <span class="count-container">
                                            <span v-show="activity.statusSummary.success">
                                                <tick-icon class="icon-default ticksimple"></tick-icon>
                                                <span class="count">{{activity.statusSummary.success}}</span>
                                            </span>
                                        </span>
                                        <span class="count-container">
                                            <span v-show="activity.statusSummary.error">
                                                <alert-icon class="icon-default error"></alert-icon>
                                                <span class="count">{{activity.statusSummary.error}}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="a-action-btns">
                                        <b-btn variant="flat" class="reportissue-btn icon-button" @click="$emit('openReportIssue',activity,$event)">
                                            <report-issue-icon class="icon-default reportissue"> </report-issue-icon>
                                            Report Issue
                                        </b-btn>
                                        <b-btn variant="flat" class="delete-btn icon-button" @click="$emit('deleteLog',activity,$event)">
                                            <delete-icon class="icon-default delete-icon"></delete-icon>
                                            Delete
                                        </b-btn>
                                    </div>
                                </div>
                            </b-col>
                        </div>
                        <div class="row w-100 m-0 detail-container">
                            <b-collapse :id="activity.actionID" class="w-100" @shown="show=true" @hidden="show=false">
                                <div class="row detail-row" v-for="(activityDetail,historyID) in activity.detailedStatus" :key="historyID">
                                    <b-col>
                                        <div class="site-name">
                                            {{activityDetail.siteName}}
                                        </div>
                                        <div class="site-action-btns" v-if="activityDetail.status==='error'">
                                            <a class="viewsiteresponse-btn"  @click="$emit('openSiteResponse',activityDetail,$event)">View site response</a>
                                        </div>
                                    </b-col>
                                    <b-col class="p-0">
                                        <div class="activitydetail-label">
                                            <div v-for="(additionalDetail,index) in activityDetail.additionalDetails" :key="index">

                                                <div v-for="(detail,index) in additionalDetail.items" :key="index" class="activitydetail-title">
                                                    <div>
                                                        <tick-icon class="icon-default ticksimple" v-if="detail.status==='success'"></tick-icon>
                                                        <alert-icon v-if="detail.status==='error'" class="icon-default error"></alert-icon>
                                                        <span>{{detail.title}}</span>
                                                        <div class="overflow-icon-container" v-bind:class="detail.status">
                                                            <b-dropdown variant="link" size="lg" no-caret>
                                                                <template slot="button-content">
                                                                    <overflow-icon class="icon-default overflow show"></overflow-icon>
                                                                </template>
                                                                <b-dropdown-item @click="$emit('retryTask',detail)">Retry</b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </div>
                                                    <div class="errorMsg" v-if="detail.showErrorMsg">
                                                        {{detail.errorMsg}}
                                                    </div>
                                                </div>
                                                <div class="button-label-wrapper" v-if="additionalDetail.label">
                                                    <a class="button-label">
                                                        {{additionalDetail.label}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </b-col>
                                </div>
                            </b-collapse>
                        </div>
                    </b-row>

                </div>
            </b-col>

        </b-row>
    </div>
</template>

<script>
import MagnifierIcon from '../../assets/lens.svg';
import ReportIssueIcon from '../../assets/reportissue.svg';
import DeleteIcon from '../../assets/delete.svg';
import TickIcon from '../../assets/ticksimple.svg';
import ErrorIcon from '../../assets/error.svg';
import AlertIcon from '../../assets/alert.svg';
import OverflowIcon from '../../assets/overflow.svg';
import CloseCirleIcon from '../../assets/closecircle.svg';

export default {
  name: 'ActivityLogItem',
  props: ['activities', 'day'],
  components: {
    MagnifierIcon,
    ReportIssueIcon,
    DeleteIcon,
    TickIcon,
    ErrorIcon,
    OverflowIcon,
    AlertIcon,
    CloseCirleIcon
  },
  data() {
    return {
      show: false
    };
  }
};
</script>

<style>
</style>
